<form #testRoute="ngForm" class="test-route-dialog">
    <div class="request-type-container">
        <span>Request type:</span>
        <mat-radio-group class="request-type" (change)="setOkButtonStatus()" [(ngModel)]="scopeObj.requestType" [ngModelOptions]="{standalone: true}">
            <mat-radio-button *ngFor="let item of testRouteType" color="primary" [value]="item.value">{{item.text}}</mat-radio-button>
        </mat-radio-group>
    </div>

    <div class="source-route-container-in-test-route-dialog" [ngClass]="{'test-route-register': isRegister(), 'test-route-call': !isRegister()}">
        <label *ngIf="!isRegister()" class="source-test-route-container-label">Source Route</label>

        <div class="source-route-container" #sourceRouteContainer>
            <div class="user-and-host-src-container">
                <mat-form-field class="fullWidth">
                    <mat-label>Source User</mat-label>
                    <input [(ngModel)]="scopeObj.srcUser" (change)="setOkButtonStatus()" matInput name="srcUser" maxlength="255">
                </mat-form-field>
                <label class="at-label">@</label>
                <mat-form-field class="fullWidth">
                    <mat-label>Source Host</mat-label>
                    <input [(ngModel)]="scopeObj.srcHost" (change)="setOkButtonStatus()" matInput name="srcHost" maxlength="255">
                </mat-form-field>
            </div>

            <div class="connection-and-peer-con-and-node-src-container">
                <ac-input-container label="Node" customError="Node is required" (focusout)="srcNodeFocusout()"
                                    [customError]="srcNodeError" [required]="true">
                    <ac-select selectId="node-in-test-route-dialog"
                               [(acModel)]="scopeObj.selectedNode"
                               (acModelChange)="nodeSelectionHandler($event); setOkButtonStatus()"
                               [items]="optionsForNodes"
                               bindLabel="name"
                               bindValue="id">
                    </ac-select>
                </ac-input-container>

                <ac-input-container label="Peer Connection" (focusout)="srcPConFocusout()"
                                    [customError]="srcPConError" [required]="true">
                    <ac-select selectId="peer-connection-in-test-route-dialog"
                               [(acModel)]="scopeObj.selectedPCon"
                               (acModelChange)="setOkButtonStatus()"
                               [items]="optionsForPCons"
                               bindLabel="name"
                               bindValue="id">
                    </ac-select>
                </ac-input-container>

              <ac-input-container label="Reroute Peer Connection ( for Refer / 3XX )" [required]="false">
                <ac-select selectId="reroute-peer-connection-in-test-route-dialog"
                           [(acModel)]="scopeObj.selectedReroutePCon"
                           (acModelChange)="setOkButtonStatus()"
                           [items]="optionsForPCons"
                           [ngDisabled]="isReroutePconDisabled()"
                           [allowClear]="true"
                           bindLabel="name"
                           bindValue="id">
                </ac-select>
              </ac-input-container>

                <div *ngIf="scopeObj.selectedPCon && scopeObj.selectedPConObj.peerConnectionNodeType === 'Virtual'">
                    <ac-input-container label="Connection" [customError]="srcConnectionError" (focusout)="srcConnectionFocusout()"
                                        [required]="true">
                        <ac-select selectId="connection-in-test-route-dialog"
                                   [(acModel)]="scopeObj.selectedConnection"
                                   (acModelChange)="setOkButtonStatus()"
                                   [items]="optionsForConnections"
                                   bindLabel="name"
                                   bindValue="id">
                        </ac-select>
                    </ac-input-container>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!isRegister()" class="destination-route-container-in-test-route-dialog">
        <label class="dest-test-route-container-label">Destination Route</label>

        <div class="user-and-host-dest-container">
            <mat-form-field class="fullWidth">
                <mat-label>Destination User</mat-label>
                <input [(ngModel)]="scopeObj.destUser" (change)="setOkButtonStatus()"
                       matInput name="destUser" maxlength="255">
            </mat-form-field>
            <label class="at-label">@</label>
            <mat-form-field class="fullWidth">
                <mat-label>Destination Host</mat-label>
                <input [(ngModel)]="scopeObj.destHost" (change)="setOkButtonStatus()"
                       matInput name="destHost" maxlength="255">
            </mat-form-field>
        </div>
    </div>
  <mat-error *ngIf="!regex.exec(scopeObj.srcUser) || !regex.exec(scopeObj.destUser)" class="uris-error">
    'Source user' and 'Destination user' fields may contain English letters, numbers, or one of the
     following characters +,#,*, ., =
  </mat-error>
    <mat-error [ngStyle]="{'visibility': isInvalidUrls() ? 'visible' : 'hidden' }"
               class="uris-error">At least one of the URIs must be filled</mat-error>

    <ac-line-separator title="Advanced Options" [(collapsed)]="isCollapsed" [isCollapsible]="true">
        <div class="test-route-mode-outer">
            <div class="radio-button-wrapper" *ngIf="!isOffline">
                <span class="radio-button-label">Include routing rules in the following mode:</span>
                <mat-radio-group [(ngModel)]="scopeObj.useOnlyActiveRules" [ngModelOptions]="{standalone: true}">
                    <mat-radio-button *ngFor="let option of testRouteMode.options" color="primary" [value]="option.value">{{option.text}}</mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="radio-button-wrapper" *ngIf="!isRegister()">
                <span class="radio-button-label">Call trigger:</span>
                <mat-radio-group [(ngModel)]="scopeObj.callTrigger" [ngModelOptions]="{standalone: true}">
                    <mat-radio-button *ngFor="let option of callTrigger.options" color="primary" [value]="option.value">{{option.text}}</mat-radio-button>
                </mat-radio-group>
            </div>

            <ac-input-container class="router-select" label="Router">
                <ac-select selectId="router-in-test-route-dialog"
                           [(acModel)]="scopeObj.router"
                           [searchable]="false"
                           [items]="optionsForRouters"
                           bindLabel="name"
                           bindValue="id">
                </ac-select>
            </ac-input-container>

          <div class="advance-sip-header">
                <span class="advance-sip-header-label">Sip headers:</span>

                <div class="sip-headers-container">
                    <div class="sip-headers-box">
                        <div *ngFor="let item of scopeObj.sipHeaders;let isOdd = odd;let isEven = even; let index = index;"
                             class="sip-headers-item"
                             [ngClass]="{'mark-selected': selectionSipHeader === index, 'odd': index % 2 === 0}"
                             (click)="sipHeaderSelected(index)"
                             [class.white]="isOdd"
                             [class.gray]="isEven">

                            <ac-select [(acModel)]="item.name"
                                       (acModelChange)="setOkButtonStatus()"
                                       [items]="availableSipHeadersOptions"
                                       [addCustomTags]="true"
                                       [searchable]="true"
                                       [allowClear]="true"
                                       selectId="sip-header-name"
                                       [attr.alternativeName]="index + '-sip-header-name'">
                            </ac-select>

                            <mat-form-field class="fullWidth sip-header-value" floatLabel='never'>
                                <input [(ngModel)]="item.value" [placeholder]="generateSipHeaderPlaceholder(item)"
                                       (change)="setOkButtonStatus()"
                                       matInput [name]="'sip-header-value' + index" maxlength="255">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="sip-headers-ctrl-buttons">
                        <button (click)="addSipHeader(); setOkButtonStatus()" [disabled]="scopeObj.sipHeaders.length === (sipHeadersOptions.length + 2)"
                                cy-data="add" mat-icon-button class="sip-headers-ctrl-button" matTooltip="Add">
                            <mat-icon [svgIcon]="scopeObj.sipHeaders.length === (sipHeadersOptions.length + 2) ? 'add_disabled' : 'add'"></mat-icon>
                        </button>

                        <button (click)="removeSipHeader()" [disabled]="scopeObj.sipHeaders.length === 0" cy-data="delete" mat-icon-button
                                class="sip-headers-ctrl-button" matTooltip="Delete">
                            <mat-icon [svgIcon]="scopeObj.sipHeaders.length === 0 ? 'delete_disabled' : 'delete'"></mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <mat-error *ngIf="isInvalidSipHeaders()" class="sip-header-error">SIP header name and values cannot be null or empty</mat-error>
        </div>
    </ac-line-separator>
</form>
